module.exports = __webpack_public_path__ + "img/Nikko-Signature.794008c1.svg";